import { addFilter } from '@wordpress/hooks';
import { BlockControls } from '@wordpress/block-editor';
import { ToolbarButton } from '@wordpress/components';

const HandleLinkTargetBlankToggle = ( BlockEdit ) => {
  return ( props ) => {
    if ( props.name === 'core/paragraph' || props.name === 'core/heading' ) {
      return (
        <>
          <BlockControls>
            <ToolbarButton
              className={props.attributes.linkTargetBlank ? 'is-pressed' : ''}
              icon='external'
              label='Open links in new tab'
              onClick={() => props.setAttributes({ linkTargetBlank: !props.attributes.linkTargetBlank })}
            />
          </BlockControls>
          <BlockEdit {...props} />
        </>
      );
    };
    return <BlockEdit {...props} />;
  };
};

addFilter( 'editor.BlockEdit', 'dwt-theme/link-target-toggle', HandleLinkTargetBlankToggle );

const addLinkTargetBlankAttribute = ( settings, name ) => {
  if ( name === 'core/paragraph' || name === 'core/heading' ) {
    return {
      ...settings,
      attributes: {
        ...settings.attributes,
        linkTargetBlank: {
          type: 'boolean',
          default: false,
        },
      },
    };
  }
  return settings;
};

addFilter( 'blocks.registerBlockType', 'dwt-custom-theme/link-blank-attribute', addLinkTargetBlankAttribute );
